// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/:locale\",\"regex\":\"^/([^/]+)$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/calendar\",\"regex\":\"^/([^/]+)/calendar$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/friendly-link\",\"regex\":\"^/([^/]+)/friendly-link$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/guestbook\",\"regex\":\"^/([^/]+)/guestbook$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/portfolio\",\"regex\":\"^/([^/]+)/portfolio$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/resume\",\"regex\":\"^/([^/]+)/resume$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/statistic\",\"regex\":\"^/([^/]+)/statistic$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true}],\"staticRoutes\":[{\"path\":\"/sentry-example-page\"}]}";globalThis["_sentryRewritesTunnelPath"] = "/monitoring";globalThis["_sentryTunnelRouteMode"] = "rewrite";globalThis["_sentryNextJsVersion"] = "16.4.3";import * as Sentry from "@sentry/nextjs";

Sentry.init({
  dsn: "https://fd298ef0d5c03380a8fe786adac1c6da@o1080789.ingest.us.sentry.io/4508343764910080",

  // Add optional integrations for additional features
  integrations: [
    Sentry.replayIntegration({
      // NOTE: This will disable built-in masking. Only use this if your site has no sensitive data, or if you've already set up other options for masking or blocking relevant data, such as 'ignore', 'block', 'mask' and 'maskFn'.
      maskAllText: false,
      blockAllMedia: false,
    }),

    Sentry.feedbackIntegration({
      // Additional SDK configuration goes in here, for example:
      colorScheme: "system",
    }),

    // Add browser profiling integration to the list of integrations
    Sentry.browserTracingIntegration(),
  ],

  // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
  // tracesSampleRate: 1,
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for tracing.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
  // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
  // tracePropagationTargets: ["localhost", /^https:\/\/(www\.)?changwei\.me/i],
  // Define how likely Replay events are sampled.
  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.1,

  // Define how likely Replay events are sampled when an error occurs.
  replaysOnErrorSampleRate: 1.0,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,

  // Adds request headers and IP for users, for more info visit:
  // https://docs.sentry.io/platforms/javascript/guides/nextjs/configuration/options/#dataCollection
  // Note: since v11 the v10 `sendDefaultPii: true` behaviour is the default. Use `dataCollection`
  // to narrow down which categories of data are collected.

  // Enable logs to be sent to Sentry
  // Note: since v11 there is no option to enable logs. They are captured whenever you use
  // `Sentry.logger.*` or add a logging integration such as `Sentry.consoleLoggingIntegration()`.

  // Note: if you want to override the automatic release value, do not set a
  // `release` value here - use the environment variable `SENTRY_RELEASE`, so
  // that it will also get attached to your source maps
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
